export default "__VITE_ASSET__CqWb8HFn__"